module.exports = __webpack_public_path__ + "img/zhanli9.d7365f22.jpg";